/* Source CPI image controller plus scoped feature lists. */
(function(){if(window.NarwalInteractiveBlocks)return;window.NarwalInteractiveBlocks=true;
(function () {
  var IMAGES_SELECTOR = "[data-ndev-closable-product-intro-images]",
    ITEM_SELECTOR = ".ndev-closable-product-intro__image-item",
    DOTS_SELECTOR = "[data-ndev-closable-product-intro-dots]",
    INIT_ATTR = "data-ndev-cpi-images-init",
    ACTIVE_ATTR = "data-ndev-cpi-active-index",
    MOBILE_QUERY = "(max-width: 1023px)";
  function clamp(n, min, max) {
    return n < min ? min : n > max ? max : n;
  }
  function getItems(root) {
    return root.querySelectorAll(ITEM_SELECTOR);
  }
  function reportGA4(el) {
    var raw = el.getAttribute("data-ga4-report");
    raw && $narwal && typeof $narwal.report == "function" && $narwal.report($narwal.getJSON(raw));
  }
  function createController(root) {
    var controller = {},
      cleanup = [],
      mql = window.matchMedia ? window.matchMedia(MOBILE_QUERY) : null,
      dotsRoot = null,
      scrollRaf = 0,
      scrollEndTimer = 0,
      resizeTimer = 0,
      mutationObserver = null,
      lastReportedIdx = null,
      overlayRaf = 0;
    function on(el, type, handler, options) {
      !el || !el.addEventListener || (el.addEventListener(type, handler, options || !1), cleanup.push(function () {
        try {
          el.removeEventListener(type, handler, options || !1);
        } catch {}
      }));
    }
    function isMobileNow() {
      return mql ? !!mql.matches : window.innerWidth < 1024;
    }
    function getDotsRoot() {
      if (dotsRoot) return dotsRoot;
      var wrapper = root.parentElement;
      return wrapper ? (dotsRoot = wrapper.querySelector(DOTS_SELECTOR), dotsRoot) : null;
    }
    function syncOverlayHeight() {
      overlayRaf = 0;
      var items = getItems(root);
      if (!items || !items.length) {
        try {
          root.style.removeProperty("--ndev-cpi-overlay-height");
        } catch {}
        return;
      }
      try {
        root.style.removeProperty("--ndev-cpi-overlay-height");
      } catch {}
      for (var maxH = 0, i = 0; i < items.length; i++) {
        var overlay = items[i].querySelector(".ndev-closable-product-intro__image-overlay");
        if (overlay) {
          var h = overlay.offsetHeight || 0;
          h > maxH && (maxH = h);
        }
      }
      if (maxH > 0) try {
        root.style.setProperty("--ndev-cpi-overlay-height", Math.ceil(maxH) + "px");
      } catch {} else try {
        root.style.removeProperty("--ndev-cpi-overlay-height");
      } catch {}
    }
    function scheduleSyncOverlayHeight() {
      overlayRaf || (overlayRaf = requestAnimationFrame(syncOverlayHeight));
    }
    function shouldShowPager(items) {
      return !isMobileNow() || !items || items.length <= 1 ? !1 : root.scrollWidth - root.clientWidth > 1;
    }
    function updatePagerVisibility(items) {
      var rootEl = getDotsRoot();
      if (!rootEl) return !1;
      var show = shouldShowPager(items);
      return rootEl.hidden = !show, show;
    }
    function getActiveIndex(items) {
      var stored = parseInt(root.getAttribute(ACTIVE_ATTR), 10);
      if (!isNaN(stored) && stored >= 0 && stored < items.length) return stored;
      var defaultIndex1 = parseInt(root.getAttribute("data-default-active"), 10) || 1,
        defaultIndex0 = defaultIndex1 >= 1 && defaultIndex1 <= items.length ? defaultIndex1 - 1 : 0;
      return defaultIndex0;
    }
    function setActiveClass(items, activeIdx) {
      Array.prototype.forEach.call(items, function (item, i) {
        i === activeIdx ? item.classList.add("is-active") : item.classList.remove("is-active");
      });
    }
    function buildDots(items) {
      var rootEl = getDotsRoot();
      if (rootEl && updatePagerVisibility(items)) {
        var existing = rootEl.querySelectorAll(".ndev-closable-product-intro__images-dot").length,
          needRebuild = existing !== items.length;
        if (needRebuild) {
          rootEl.innerHTML = "";
          for (var frag = document.createDocumentFragment(), i = 0; i < items.length; i++) {
            var dot = document.createElement("button");
            dot.type = "button", dot.className = "ndev-closable-product-intro__images-dot", dot.setAttribute("aria-label", "Изображение " + (i + 1)), dot.setAttribute("data-ndev-cpi-dot-index", String(i)), frag.appendChild(dot);
          }
          rootEl.appendChild(frag), rootEl.setAttribute("data-ndev-cpi-dots-count", String(items.length));
        }
      }
    }
    function setDotsActive(activeIdx) {
      var rootEl = getDotsRoot();
      if (rootEl && !rootEl.hidden) {
        var dots = rootEl.querySelectorAll(".ndev-closable-product-intro__images-dot");
        dots.length && Array.prototype.forEach.call(dots, function (dot, i) {
          i === activeIdx ? dot.classList.add("is-active") : dot.classList.remove("is-active");
        });
      }
    }
    function scrollToIndex(items, idx, behavior) {
      if (isMobileNow() && items[idx]) {
        var rootRect = root.getBoundingClientRect(),
          itemRect = items[idx].getBoundingClientRect(),
          currentLeft = root.scrollLeft,
          itemCenter = itemRect.left - rootRect.left + currentLeft + itemRect.width / 2,
          targetLeft = itemCenter - root.clientWidth / 2,
          maxLeft = Math.max(0, root.scrollWidth - root.clientWidth);
        targetLeft < 0 && (targetLeft = 0), targetLeft > maxLeft && (targetLeft = maxLeft);
        try {
          root.scrollTo({
            left: targetLeft,
            behavior: window.matchMedia("(prefers-reduced-motion:reduce)").matches ? "auto" : behavior || "auto"
          });
        } catch {
          root.scrollLeft = targetLeft;
        }
      }
    }
    function closestIndexToCenter(items) {
      for (var center = root.scrollLeft + root.clientWidth / 2, best = 0, bestDist = 1 / 0, i = 0; i < items.length; i++) {
        var itemCenter = items[i].offsetLeft + items[i].offsetWidth / 2,
          dist = Math.abs(itemCenter - center);
        dist < bestDist && (bestDist = dist, best = i);
      }
      return best;
    }
    function closestIndexForScrollPosition(items) {
      if (!items.length) return 0;
      var maxLeft = Math.max(0, root.scrollWidth - root.clientWidth),
        left = root.scrollLeft,
        EDGE_EPS = 2;
      return maxLeft <= EDGE_EPS ? closestIndexToCenter(items) : left <= EDGE_EPS ? 0 : maxLeft - left <= EDGE_EPS ? items.length - 1 : closestIndexToCenter(items);
    }
    function setActiveIndex(nextIdx, opts) {
      var items = getItems(root);
      if (items.length) {
        updatePagerVisibility(items);
        var idx = clamp(nextIdx, 0, items.length - 1),
          prevIdx = parseInt(root.getAttribute(ACTIVE_ATTR), 10),
          changed = isNaN(prevIdx) || prevIdx !== idx,
          force = !!(opts && opts.force);
        buildDots(items), force || changed ? (root.setAttribute(ACTIVE_ATTR, String(idx)), setActiveClass(items, idx), setDotsActive(idx)) : (setActiveClass(items, idx), setDotsActive(idx)), scheduleSyncOverlayHeight(), opts && opts.scroll && scrollToIndex(items, idx, opts.behavior || "smooth"), opts && opts.report && items[idx] && (opts.reportMode === "always" ? reportGA4(items[idx]) : lastReportedIdx !== idx && (lastReportedIdx = idx, reportGA4(items[idx])));
      }
    }
    function syncToMode() {
      var items = getItems(root);
      if (items.length) {
        var idx = getActiveIndex(items);
        if (setActiveIndex(idx, {
          force: !0,
          report: !1,
          scroll: !1
        }), updatePagerVisibility(items), scheduleSyncOverlayHeight(), isMobileNow()) try {
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              var liveItems = getItems(root);
              if (liveItems.length) {
                updatePagerVisibility(liveItems);
                var active = getActiveIndex(liveItems);
                scrollToIndex(liveItems, active, "auto"), scheduleSyncOverlayHeight();
              }
            });
          });
        } catch {
          scrollToIndex(items, idx, "auto");
        } else try {
          root.scrollLeft = 0;
        } catch {}
      }
    }
    function onDotsClick(e) {
      if (isMobileNow()) {
        var rootEl = getDotsRoot();
        if (rootEl && !rootEl.hidden) {
          var target = e && e.target ? e.target : null;
          if (!(!target || !target.getAttribute)) {
            var raw = target.getAttribute("data-ndev-cpi-dot-index");
            if (raw != null) {
              var idx = parseInt(raw, 10);
              isNaN(idx) || setActiveIndex(idx, {
                scroll: !0,
                behavior: "smooth",
                report: !0,
                reportMode: "always"
              });
            }
          }
        }
      }
    }
    function onRootMouseOver(e) {
      if (!isMobileNow()) {
        var t = e && e.target ? e.target : null;
        if (t) {
          var item = t.closest ? t.closest(ITEM_SELECTOR) : null;
          if (!(!item || !root.contains(item)) && !(e.relatedTarget && item.contains(e.relatedTarget))) {
            var items = getItems(root),
              idx = Array.prototype.indexOf.call(items, item);
            idx < 0 || setActiveIndex(idx, {
              report: !0,
              reportMode: "once"
            });
          }
        }
      }
    }
    function onRootClick(e) {
      if (!isMobileNow()) {
        var t = e && e.target ? e.target : null;
        if (t) {
          var item = t.closest ? t.closest(ITEM_SELECTOR) : null;
          if (!(!item || !root.contains(item))) {
            var items = getItems(root),
              idx = Array.prototype.indexOf.call(items, item);
            idx < 0 || setActiveIndex(idx, {
              report: !0,
              reportMode: "always"
            });
          }
        }
      }
    }
    function onScroll() {
      isMobileNow() && (root.scrollWidth - root.clientWidth <= 1 || scrollRaf || (scrollRaf = requestAnimationFrame(function () {
        scrollRaf = 0;
        var items = getItems(root);
        if (items.length) {
          updatePagerVisibility(items);
          var idx = closestIndexForScrollPosition(items);
          setActiveIndex(idx, {
            report: !1,
            scroll: !1
          }), scrollEndTimer && clearTimeout(scrollEndTimer), scrollEndTimer = setTimeout(function () {
            var liveItems = getItems(root);
            if (liveItems.length) {
              var finalIdx = closestIndexForScrollPosition(liveItems);
              setActiveIndex(finalIdx, {
                report: !0,
                reportMode: "once",
                scroll: !1
              });
            }
          }, 140);
        }
      })));
    }
    function onResize() {
      isMobileNow() && (resizeTimer && clearTimeout(resizeTimer), resizeTimer = setTimeout(function () {
        var items = getItems(root);
        if (items.length) {
          var showPager = updatePagerVisibility(items),
            idx = getActiveIndex(items);
          showPager && scrollToIndex(items, idx, "auto"), scheduleSyncOverlayHeight();
        }
      }, 120));
    }
    function onModeChange() {
      syncToMode();
    }
    function observeMutations() {
      window.MutationObserver && (mutationObserver = new MutationObserver(function () {
        var items = getItems(root);
        if (items.length) {
          var showPager = updatePagerVisibility(items);
          buildDots(items);
          var idx = getActiveIndex(items);
          setActiveIndex(idx, {
            force: !0,
            report: !1,
            scroll: !1
          }), showPager && scrollToIndex(items, idx, "auto"), scheduleSyncOverlayHeight();
        }
      }), mutationObserver.observe(root, {
        childList: !0
      }), cleanup.push(function () {
        try {
          mutationObserver.disconnect();
        } catch {}
        mutationObserver = null;
      }));
    }
    controller.refresh = function () {
      var items = getItems(root);
      if (items.length) {
        buildDots(items);
        var idx = getActiveIndex(items);
        setActiveIndex(idx, {
          force: !0,
          report: !1,
          scroll: !1
        }), syncToMode(), scheduleSyncOverlayHeight();
      }
    }, controller.destroy = function () {
      scrollEndTimer && clearTimeout(scrollEndTimer), resizeTimer && clearTimeout(resizeTimer), scrollRaf && cancelAnimationFrame(scrollRaf), overlayRaf && cancelAnimationFrame(overlayRaf);
      for (var i = 0; i < cleanup.length; i++) cleanup[i]();
      cleanup = [], dotsRoot = null;
      try {
        delete root.__ndevCpiImagesController;
      } catch {}
      try {
        root.removeAttribute(INIT_ATTR);
      } catch {}
      try {
        root.classList.remove("is-ready");
      } catch {}
    }, on(root, "mouseover", onRootMouseOver), on(root, "click", onRootClick), on(root, "scroll", onScroll, {
      passive: !0
    }), on(window, "resize", onResize);
    var dRoot = getDotsRoot();
    return dRoot && on(dRoot, "click", onDotsClick), mql && (typeof mql.addEventListener == "function" ? (mql.addEventListener("change", onModeChange), cleanup.push(function () {
      try {
        mql.removeEventListener("change", onModeChange);
      } catch {}
    })) : typeof mql.addListener == "function" && (mql.addListener(onModeChange), cleanup.push(function () {
      try {
        mql.removeListener(onModeChange);
      } catch {}
    }))), observeMutations(), root.setAttribute(INIT_ATTR, "1"), controller.refresh(), root.classList.contains("is-ready") || root.classList.add("is-ready"), on(window, "load", scheduleSyncOverlayHeight), on(root, "transitionend", function (e) {
      var t = e && e.target ? e.target : null;
      !t || !t.classList || t.classList.contains("ndev-closable-product-intro__image-overlay-desc") && scheduleSyncOverlayHeight();
    }), controller;
  }
  function initImages(root) {
    if (root) {
      var items = getItems(root);
      if (items.length) {
        if (root.__ndevCpiImagesController && root.__ndevCpiImagesController.refresh) {
          root.__ndevCpiImagesController.refresh();
          return;
        }
        root.__ndevCpiImagesController = createController(root);
      }
    }
  }
  function initAll(scope) {
    var base = scope && scope.querySelectorAll ? scope : document,
      roots = base.querySelectorAll(IMAGES_SELECTOR);
    Array.prototype.forEach.call(roots, initImages);
  }
  document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", function () {
    initAll();
  }) : initAll(), document.addEventListener("shopify:section:load", function (e) {
    initAll(e && e.target ? e.target : null);
  }), document.addEventListener("shopify:section:unload", function (e) {
    var scope = e && e.target ? e.target : null;
    if (!(!scope || !scope.querySelectorAll)) {
      var roots = scope.querySelectorAll(IMAGES_SELECTOR);
      Array.prototype.forEach.call(roots, function (root) {
        root && root.__ndevCpiImagesController && root.__ndevCpiImagesController.destroy && root.__ndevCpiImagesController.destroy();
      });
    }
  });
})();
(function () {
  'use strict';
  const states = new Map(), reduce = matchMedia('(prefers-reduced-motion:reduce)');
  window.NarwalFeatureLists = { states };
  const skip = new Set(['STYLE', 'SCRIPT', 'LINK', 'NOSCRIPT', 'TEMPLATE']);
  function init(root) {
    if (states.has(root)) return;
    const frame = root.querySelector('[data-ndev-swiper-list-frame]'), track = root.querySelector('[data-ndev-swiper-list-track]');
    if (!frame || !track) return;
    const items = [...track.children].filter(e => !skip.has(e.tagName)); if (!items.length) return;
    const abort = new AbortController(), pagination = root.querySelector('[data-ndev-swiper-list-pagination]'), current = root.querySelector('[data-ndev-swiper-list-pagination-current]'), total = root.querySelector('[data-ndev-swiper-list-pagination-total]'), prev = root.querySelector('.ndev-swiper-list__pagination-button--prev'), next = root.querySelector('.ndev-swiper-list__pagination-button--next');
    const on = (node, event, fn) => node?.addEventListener(event, fn, { signal: abort.signal });
    const sourceAuto = root.dataset.autoplay === 'true', delay = Number(root.dataset.autoplaySpeed) || 3000;
    let index = 0, interval = 0, inView = false, userPaused = false, manualOptIn = false, raf = 0;
    const toggle = sourceAuto ? document.createElement('button') : null;
    if (toggle) { toggle.type = 'button'; toggle.className = 'ndev-swiper-list__pagination-button nwb-swiper-list__autoplay'; next?.parentElement.insertBefore(toggle, next); }
    const icon = pause => pause ? '<svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true"><path d="M6 3v12M12 3v12" stroke="currentColor" stroke-width="3"/></svg>' : '<svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true"><path d="M5 2l11 7-11 7z" fill="currentColor"/></svg>';
    function caption() { if (!toggle) return; const enabled = !userPaused && (!reduce.matches || manualOptIn); toggle.innerHTML = icon(enabled); toggle.setAttribute('aria-label', enabled ? 'Приостановить карусель' : 'Воспроизвести карусель'); }
    function transformFor(item) {
      const fr = frame.getBoundingClientRect(), style = getComputedStyle(frame), left = fr.left + (parseFloat(style.borderLeftWidth) || 0) + (parseFloat(style.paddingLeft) || 0), width = frame.clientWidth;
      if (!width) return 0;
      const cr = item.getBoundingClientRect(), tr = track.getBoundingClientRect(); let tx = 0;
      try { const value = getComputedStyle(track).transform; if (value !== 'none') tx = new DOMMatrixReadOnly(value).m41; } catch (_) {}
      let delta = left + width / 2 - (cr.left + cr.width / 2);
      delta = Math.max(left - cr.left, Math.min(delta, left + width - cr.right));
      if (track.offsetWidth > width + .5) delta = Math.max(left + width - tr.right, Math.min(delta, left - tr.left));
      return tx + delta;
    }
    function position(animate) {
      const instant = !animate || reduce.matches;
      track.classList.toggle('ndev-swiper-list__track--instant', instant);
      track.style.transform = 'translate3d(' + transformFor(items[index]) + 'px,0,0)';
      if (instant) { void track.offsetWidth; track.classList.remove('ndev-swiper-list__track--instant'); }
    }
    function activate(nextIndex, animate = true) {
      index = (nextIndex + items.length) % items.length;
      items.forEach((item, i) => { item.classList.toggle('actived', i === index); item.setAttribute('aria-current', String(i === index)); });
      if (current) current.textContent = String(index + 1).padStart(2, '0');
      if (total) total.textContent = '/' + String(items.length).padStart(2, '0');
      root.dataset.nwbSwiperListIndex = String(index); position(animate);
    }
    function syncAuto() {
      const focus = root.contains(document.activeElement), hover = root.matches(':hover');
      const play = sourceAuto && items.length > 1 && !userPaused && inView && !document.hidden && (!reduce.matches || manualOptIn) && ((!focus && !hover) || manualOptIn);
      if (!play && interval) { clearInterval(interval); interval = 0; }
      if (play && !interval) interval = setInterval(() => activate(index + 1), delay);
      caption();
    }
    function manual(nextIndex) { activate(nextIndex); if (interval) { clearInterval(interval); interval = 0; } syncAuto(); }
    on(prev, 'click', () => manual(index - 1)); on(next, 'click', () => manual(index + 1));
    on(toggle, 'click', () => { if (userPaused || (reduce.matches && !manualOptIn)) { userPaused = false; manualOptIn = true; } else { userPaused = true; manualOptIn = false; } syncAuto(); });
    on(track, 'click', event => { let node = event.target; while (node && node.parentElement !== track) node = node.parentElement; const i = items.indexOf(node); if (i >= 0) manual(i); });
    frame.tabIndex = 0; frame.setAttribute('role', 'region'); frame.setAttribute('aria-roledescription', 'carousel'); frame.setAttribute('aria-label', 'Характеристики продукта');
    on(frame, 'keydown', event => { if (event.target.matches('input,textarea,select')) return; if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); manual(index + (event.key === 'ArrowRight' ? 1 : -1)); } });
    on(root, 'mouseenter', syncAuto); on(root, 'mouseleave', syncAuto); on(root, 'focusin', syncAuto); on(root, 'focusout', () => queueMicrotask(() => { if (!abort.signal.aborted) syncAuto(); }));
    on(document, 'visibilitychange', syncAuto); on(reduce, 'change', () => { manualOptIn = false; position(false); syncAuto(); });
    const io = new IntersectionObserver(entries => { inView = entries[0].isIntersecting; syncAuto(); }); io.observe(root);
    const resize = new ResizeObserver(() => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => position(false)); }); resize.observe(frame);
    if (pagination) { const lock = root.dataset.hidePaginationOnePage !== 'false' && items.length <= 1; pagination.classList.toggle('ndev-swiper-list__pagination--lock', lock); pagination.setAttribute('aria-hidden', String(lock)); }
    if (prev) prev.disabled = items.length <= 1; if (next) next.disabled = items.length <= 1;
    root.setAttribute('data-ndev-swiper-list-initialized', '1'); activate(0, false); caption();
    states.set(root, { destroy() { abort.abort(); io.disconnect(); resize.disconnect(); clearInterval(interval); cancelAnimationFrame(raf); toggle?.remove(); root.removeAttribute('data-ndev-swiper-list-initialized'); states.delete(root); } });
  }
  function scan(scope) { scope.querySelectorAll('[data-ndev-swiper-list]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true }); else scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => { for (const [root, state] of states) if (event.target.contains(root)) state.destroy(); });
}());

}());